import { useMemo } from 'react';
import { BrandAffinityLevel } from 'modules/domains';

import { useTranslation } from '../../../../hooks/useTranslation';
import { doesBrandAffinityMatchSearch } from './doesBrandAffinityMatchSearch';

type UseBrandAffinityOptionsProps = {
  search: string;
};

export const useBrandAffinityOptions = ({ search }: UseBrandAffinityOptionsProps) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      Object.values(BrandAffinityLevel)
        .map((level) => ({
          title: t(`v2.conditionBuilder.brandAffinity.${level}`),
          value: level.toString(),
        }))
        .filter((option) => doesBrandAffinityMatchSearch(option.title, search))
        .sort(({ title: a }, { title: b }) => a.localeCompare(b)),
    [t, search],
  );
};
